import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
const styles = {
  root: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    boxShadow: "none",
    "@media (max-width: 665px)": {
      fontSize: "16px",
    },
  },
  input: {
    marginLeft: 8,
    flex: 1,
    color: "#979797",
    fontSize: "14px",
    padding: "0 5px",
    "@media (max-width: 665px)": {
      fontSize: "16px",
    },
  },
  iconButton: {
    padding: 6,
  },
};

const KeywordSearch = (props) => {
  const {
    classes,
    keyword,
    keywordInput,
    keywordSubmit,
    keywordType,
    id,
    tourId,
  } = props;
  return (
    // <KeywordWrap>
    //     <Input
    //         onChange={keywordInput}
    //         onKeyPress={e => e.key === "Enter" && keywordSubmit()}
    //         value={keyword} type="text" placeholder={keywordType}
    //     />
    // </KeywordWrap>
    <Paper id={tourId} className={classes.root} elevation={1}>
      <IconButton className={classes.iconButton} aria-label="Menu"></IconButton>
      <InputBase
        id={id}
        className={classes.input}
        placeholder={keywordType}
        onInput={keywordInput}
        onKeyPress={(e) => e.key === "Enter" && keywordSubmit()}
        value={keyword}
        type="text"
      />
      <IconButton
        onClick={() => keywordSubmit()}
        className={classes.iconButton}
        aria-label="Search"
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};
KeywordSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    messages: state.Messages,
  };
};
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(KeywordSearch))
);



// WEBPACK FOOTER //
// ./src/InfoList/Search/dev/KeywordSearch.js